import { calculateAgeForHost } from "./AgeCalculator";
import { figureMap } from "./FigureMap";
import { sexualityMap } from "./SexualityMap";
export default function replacePlaceholders(text, host) {
  if (!host || text === undefined) {
    return text;
  }
  var years = calculateAgeForHost(host);
  return text.replace(/{{name}}/gi, host.name).replace(/{{age}}/gi, years.toString()).replace(/{{figure}}/gi, figureMap[host.figure]).replace(/{{sexuality}}/gi, sexualityMap[host.sexuality]).replace(/{{height}}/gi, host.height.toString()).replace(/{{cupSize}}/gi, host.breastSize);
}
export function decodeHtmlEntities(string) {
  var textArea = document.createElement('textarea');
  textArea.innerHTML = string;
  return textArea.value;
}